import type {
  AddMemberRequest,
  ContentCollectionPatch,
  ContentReference as ContentReferenceDef,
  ContentsByReferences as ContentsByReferencesDef,
  CreateContentCollectionRequest,
  Cursor,
  RemoveMemberRequest,
} from '@ilteducation/content-collections-types';
import type { Content } from '@ilteducation/content-registry-types';

export type Filter = { [key: string]: string | string[] };

export type ViewCollectionsQuery = {
  cursor?: string | undefined | null;
  limit?: number;
};

export type ContentQuery = {
  filter?: Filter;
  cursor?: Cursor;
  limit?: number | undefined;
};

// TODO remove all duplicated types, let dependants import on their own?

export type ContentReference = ContentReferenceDef;

export type ContentsByReferences = ContentsByReferencesDef;

export type NewContentCollection = Omit<CreateContentCollectionRequest, 'owners'>;

export type CollectionPatch = ContentCollectionPatch;

export type CollectionFormPatch = Pick<CollectionPatch, 'name' | 'icon'>;

export type AddMemberParams = AddMemberRequest;

export type RemoveMemberParams = RemoveMemberRequest;

// TODO make it universal just hardcoded for now as we don't have any other filters
export type ContentFilters = {
  ages: number[];
  audioLanguages: string[] | string;
  textLanguages: string;
  subscription: string;
  contentTypes?: Content['type'][];
};

export enum MemberRole {
  Owner = 'owner',
  Member = 'member',
  Subscriber = 'subscriber',
}
